/* eslint-disable */
// AUTO-GENERATED from VID Manual Issue L (February 2022) valving schedule tables.
// Do not edit by hand. Source: scripts/buildVidValveData.py
// Generated data is a typed transcription of the schedule tables + type index.
// Torque is applied from vidTorque.js (Section 10, page 265) by fitting type.

export const VID_TYPES = {
  "001": {
    "code": "001",
    "name": "100V",
    "drawing": "14253",
    "alternatives": [
      "019",
      "010"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "002": {
    "code": "002",
    "name": "100H",
    "drawing": "14252",
    "alternatives": [
      "019",
      "010"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "003": {
    "code": "003",
    "name": "200KG EX SWG (EUROWELD)",
    "drawing": "14408",
    "alternatives": [
      "019",
      "010"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "004": {
    "code": "004",
    "name": "100HF MK I (S)",
    "drawing": "14087",
    "alternatives": [
      "019",
      "010"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "005": {
    "code": "005",
    "name": "100HF MK II (S)",
    "drawing": "14663",
    "alternatives": [
      "019",
      "010"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "006": {
    "code": "006",
    "name": "100 HF MK I",
    "drawing": "14578",
    "alternatives": [
      "019",
      "010"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "007": {
    "code": "007",
    "name": "100 HF MK II",
    "drawing": "14580",
    "alternatives": [
      "019",
      "010"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "008": {
    "code": "008",
    "name": "200 KG (BS1515)",
    "drawing": "14661",
    "alternatives": [
      "019",
      "010"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "009": {
    "code": "009",
    "name": "200 KG (BS5500)",
    "drawing": "14715",
    "alternatives": [
      "010",
      "044"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "010": {
    "code": "010",
    "name": "200 KG (BS1500)",
    "drawing": "14287",
    "alternatives": [
      "009",
      "044"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "011": {
    "code": "011",
    "name": "200 KG (800 DIAMETER)",
    "drawing": "14582",
    "alternatives": [],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "ok"
  },
  "013": {
    "code": "013",
    "name": "200 KG (ASME)",
    "drawing": "14584",
    "alternatives": [
      "019",
      "014"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "ok"
  },
  "014": {
    "code": "014",
    "name": "380 LITRE STD (NO DRAIN)",
    "drawing": "14976",
    "alternatives": [
      "019",
      "013"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "ok"
  },
  "019": {
    "code": "019",
    "name": "380 LITRE STD (WITH DRAIN)",
    "drawing": "14283",
    "alternatives": [
      "014",
      "013"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "ok"
  },
  "026": {
    "code": "026",
    "name": "380 LITRE EX - SIS",
    "drawing": "15106",
    "alternatives": [
      "019",
      "014"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "039": {
    "code": "039",
    "name": "380 LITRE 5 VALVE EX LOW PRESS",
    "drawing": null,
    "alternatives": [],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "041": {
    "code": "041",
    "name": "380 LITRE COMPETITION COMMISSION TRANSFER",
    "drawing": null,
    "alternatives": [],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "identify"
  },
  "043": {
    "code": "043",
    "name": "380 LITRE 5 VALVE EX",
    "drawing": null,
    "alternatives": [],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "obsolete"
  },
  "044": {
    "code": "044",
    "name": "380 LITRE 3 VALVE EX EUROWELD TYPE010",
    "drawing": "20199",
    "alternatives": [
      "010",
      "009"
    ],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "ok"
  },
  "113": {
    "code": "113",
    "name": "1000 LITRE COMPETITION COMMISSION TRANSFER",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "identify"
  },
  "114": {
    "code": "114",
    "name": "1000 LITRE HEADER TANK (LAKENHEATH) None None",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "refer"
  },
  "115": {
    "code": "115",
    "name": "1200 LITRE EX WEF3 0133 0121",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "116": {
    "code": "116",
    "name": "1000 LITRE 5 VALVE EX",
    "drawing": "20077",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "117": {
    "code": "117",
    "name": "156 GALLON VESSEL",
    "drawing": "14248",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "118": {
    "code": "118",
    "name": "1000 LITRE EX MAR (15.7 BAR)",
    "drawing": "15037",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "119": {
    "code": "119",
    "name": "1000 LITRE EX MAR (18.68 BAR)",
    "drawing": "15036",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "120": {
    "code": "120",
    "name": "500 KG PROPANE VESSEL",
    "drawing": "14311",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "121": {
    "code": "121",
    "name": "1200 LT STD (WITH DRAIN)",
    "drawing": "14284",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "123": {
    "code": "123",
    "name": "310 TYPE STORAGE VESSEL",
    "drawing": "14510",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "124": {
    "code": "124",
    "name": "12 CWT (EX SWG)",
    "drawing": "13906",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "125": {
    "code": "125",
    "name": "12 CWT SWG (VAN LEER)",
    "drawing": "14002",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "indexed"
  },
  "126": {
    "code": "126",
    "name": "12 CWT SWG (BUTTERFIELD)",
    "drawing": "14019",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "indexed"
  },
  "127": {
    "code": "127",
    "name": "12 CWT SWG (EUROWELD)",
    "drawing": "14238",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "indexed"
  },
  "128": {
    "code": "128",
    "name": "310F MK I STORAGE VESSEL",
    "drawing": "14277",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "129": {
    "code": "129",
    "name": "310F MK II STORAGE VESSEL",
    "drawing": "14282",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "130": {
    "code": "130",
    "name": "600 KG (BS1515) STORAGE VESSEL",
    "drawing": "14288",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "131": {
    "code": "131",
    "name": "1200 OPS VAC KNOCK OUT",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "identify"
  },
  "132": {
    "code": "132",
    "name": "600 KG (BS5500) STORAGE VESSEL",
    "drawing": "14716",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "133": {
    "code": "133",
    "name": "1200 LITRE STD (NO DRAIN)",
    "drawing": "14977",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "134": {
    "code": "134",
    "name": "310 EX-SWG (AMF)",
    "drawing": "14237",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "135": {
    "code": "135",
    "name": "14 CWT SWG (VAN LEER)",
    "drawing": "14233",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "136": {
    "code": "136",
    "name": "352 GALLON VESSEL",
    "drawing": "14255",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "137": {
    "code": "137",
    "name": "310 F MK2 PLANER 0133 0121",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "refer"
  },
  "138": {
    "code": "138",
    "name": "Customer Owned tank",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "indexed"
  },
  "139": {
    "code": "139",
    "name": "1800 LBS MK I (MASTERS)",
    "drawing": "14204",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "140": {
    "code": "140",
    "name": "1800 LBS MK II (ROBERTS)",
    "drawing": "14206",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "145": {
    "code": "145",
    "name": "1200 LITRE EX MIT/MAR VL1",
    "drawing": "15023",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "146": {
    "code": "146",
    "name": "1200 LITRE EX MBF 1",
    "drawing": "15007",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "147": {
    "code": "147",
    "name": "1200 LITRE EX MIT. MBF 2",
    "drawing": "15008",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "148": {
    "code": "148",
    "name": "1200 LITRE EX MIT. MBF 3",
    "drawing": "15009",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "149": {
    "code": "149",
    "name": "1200 LITRE EX MIT. VL 2",
    "drawing": "15024",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "150": {
    "code": "150",
    "name": "1200 LITRE EX MIT. WEF 1",
    "drawing": "15010",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "151": {
    "code": "151",
    "name": "1200 LITRE EX MIT. WEF 2",
    "drawing": "15011",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "152": {
    "code": "152",
    "name": "1200 LITRE EX MIT. WEF 3",
    "drawing": "15012",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "153": {
    "code": "153",
    "name": "1200 LITRE EX MAR. VL 3",
    "drawing": "15027",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "154": {
    "code": "154",
    "name": "1200 LITRE EX. McK 1",
    "drawing": "15013",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "155": {
    "code": "155",
    "name": "1200 LITRE ROAD PLANER",
    "drawing": "15058",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "156": {
    "code": "156",
    "name": "1400 LITRE AGRICULTURAL",
    "drawing": "18414",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "157": {
    "code": "157",
    "name": "1350 LITRE CLYDE PORT",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "refer"
  },
  "158": {
    "code": "158",
    "name": "1200 LITRE 5-IN-LINE",
    "drawing": "18415",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "160": {
    "code": "160",
    "name": "1400 LITRE 5 VALVE EX",
    "drawing": "18812",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "162": {
    "code": "162",
    "name": "1730 LITRE 5 VALVE EX",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "163": {
    "code": "163",
    "name": "1200 LITRE 5 V EX LOW PRESSURE",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "164": {
    "code": "164",
    "name": "1200 LITRE COMPETITION COMMISSION TRANSFER",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "identify"
  },
  "165": {
    "code": "165",
    "name": "1200 LITRE UNDERGROUND COMPETITION COMMISSION TRANSFER",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "identify"
  },
  "166": {
    "code": "166",
    "name": "1400 LITRE COMPETITION COMMISSION TRANSFER",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "identify"
  },
  "167": {
    "code": "167",
    "name": "1200 LITRE Ex BG WEFCO 4 NO DRAIN",
    "drawing": "20167",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "refer"
  },
  "168": {
    "code": "168",
    "name": "1600 LITRE COMPETITION COMMISSION TRANSFER",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "identify"
  },
  "169": {
    "code": "169",
    "name": "1200 LITRE EX TYPE 128 (BS1500) & 129 (BS1515)",
    "drawing": "20136",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "170": {
    "code": "170",
    "name": "1200 LITRE 3 HOLE EX",
    "drawing": "20163",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "171": {
    "code": "171",
    "name": "1500 LITRE 5 HOLE EX LIQUIGAS AG",
    "drawing": "20171",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "172": {
    "code": "172",
    "name": "1500 LITRE 5 HOLE EX LIQUIGAS UG",
    "drawing": "20172",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "173": {
    "code": "173",
    "name": "1200 LITRE EX TYPE 123 (B.S.1500 ROBERTS BROS. ONLY)",
    "drawing": "20333",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "obsolete"
  },
  "180": {
    "code": "180",
    "name": "1650 LITRE 5 HOLE VERTICAL UG",
    "drawing": "21863",
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "201": {
    "code": "201",
    "name": "1200 LITRE 5 HOLE EX EUROGAS UG REQUALIFIED",
    "drawing": null,
    "alternatives": [],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "159": {
    "code": "159",
    "name": "1200 LITRE 5 VALVE EX",
    "drawing": "18806",
    "alternatives": [
      "158"
    ],
    "capacity": "1200 L",
    "indexPage": 30,
    "section": 2,
    "status": "ok"
  },
  "202": {
    "code": "202",
    "name": "2000 Litre 5 HOLE EX EUROGAS UG REQUALIFIED",
    "drawing": null,
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "indexed"
  },
  "220": {
    "code": "220",
    "name": "2000 LITRE CAPACITY UNDERGROUND VESSEL (EX 233)",
    "drawing": "20237",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "224": {
    "code": "224",
    "name": "1 TONNE CAPACITY RECOVERY STORAGE VESSEL",
    "drawing": "20227",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "refer"
  },
  "225": {
    "code": "225",
    "name": "2000 LITRE 5 VALVE - ADDITIONAL VAPOUR CONNECTION",
    "drawing": "20074",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "226": {
    "code": "226",
    "name": "2000 LITRE GLI (Schneider) STANDARD 0236 0292",
    "drawing": null,
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "refer"
  },
  "227": {
    "code": "227",
    "name": "2100 LITRE SHV STANDARD UNDERGROUND",
    "drawing": "20057",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "228": {
    "code": "228",
    "name": "2000 LITRE 4 L EX WEF 4",
    "drawing": "19655",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "229": {
    "code": "229",
    "name": "2000 LITRE 1850 L LOW PRESS 5 VALVE EX",
    "drawing": "19200",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "231": {
    "code": "231",
    "name": "2000 LITRE EX WEF 3",
    "drawing": "18990",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "232": {
    "code": "232",
    "name": "2001 LITRE 5-IN-LINE UNDERGROUND",
    "drawing": "18416",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "233": {
    "code": "233",
    "name": "2000 LITRE SKID VESSEL",
    "drawing": "18417",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "234": {
    "code": "234",
    "name": "1860 LITRE 5 VALVE EX",
    "drawing": "18807",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "235": {
    "code": "235",
    "name": "1900 LITRE 5 VALVE EX",
    "drawing": "18808",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "236": {
    "code": "236",
    "name": "2000 LITRE 5 VALVE EX",
    "drawing": "18809",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "237": {
    "code": "237",
    "name": "2000 LITRE MARINE VESSEL",
    "drawing": "18418",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "238": {
    "code": "238",
    "name": "2000 LITRE 5-IN-LINE",
    "drawing": "18419",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "239": {
    "code": "239",
    "name": "2000 LITRE ROAD PLANER",
    "drawing": "18420",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "241": {
    "code": "241",
    "name": "1 Te ROAD PLANER VESSEL (AMF)",
    "drawing": "15026",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "242": {
    "code": "242",
    "name": "1 TON EX SWG (EUROWELD)",
    "drawing": "14234",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "243": {
    "code": "243",
    "name": "1 TON EX SWG",
    "drawing": "14511",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "244": {
    "code": "244",
    "name": "1 TON NON STD (EUROWELD)",
    "drawing": "14038",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "245": {
    "code": "245",
    "name": "1 TON EX SWG (VAN LEER) COMBO VALVE VERSION",
    "drawing": "14132",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "246": {
    "code": "246",
    "name": "1 TON EX SWG (VAN LEER) MULTIVALVE VERSION",
    "drawing": "13980",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "247": {
    "code": "247",
    "name": "1 TON EX SWG (W MIDLANDS)",
    "drawing": "14027",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "248": {
    "code": "248",
    "name": "1 TON EX BOC (AMF) MULTIVALVE VERSION",
    "drawing": "14037",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "249": {
    "code": "249",
    "name": "1 TON EX SWG (BUTTERFIELD)",
    "drawing": "14417",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "250": {
    "code": "250",
    "name": "1 TON EX BOC (AMF) COMBO VALVE VERSION",
    "drawing": "14134",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "251": {
    "code": "251",
    "name": "1 TON F MK II",
    "drawing": "14281",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "252": {
    "code": "252",
    "name": "1 TON F MK III",
    "drawing": "14276",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "253": {
    "code": "253",
    "name": "1 TON F MK 1",
    "drawing": "14278",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "254": {
    "code": "254",
    "name": "1 TONNE (BS 1515)",
    "drawing": "14289",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "255": {
    "code": "255",
    "name": "1 TON EX SWG (ROBERTS)",
    "drawing": "14239",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "256": {
    "code": "256",
    "name": "1 TONNE (BS 5500)",
    "drawing": "14717",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "257": {
    "code": "257",
    "name": "1 TON EX SWG (ROBERTS)",
    "drawing": "14026",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "258": {
    "code": "258",
    "name": "2000 LITRE STD (BS 5500)",
    "drawing": "14285",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "259": {
    "code": "259",
    "name": "1 TON EX SWG (W MIDLANDS) COMBOVALVE VERSION",
    "drawing": "14135",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "260": {
    "code": "260",
    "name": "1 TON EX SWG (ROBERTS) COMBOVALVE VERSION",
    "drawing": "14131",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "261": {
    "code": "261",
    "name": "1 TON EX SWG (ROBERTS) MULTIVALVE VERSION",
    "drawing": "14025",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "262": {
    "code": "262",
    "name": "1 TON NON STD (ROBERTS)",
    "drawing": "14454",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "266": {
    "code": "266",
    "name": "1 TON McNEIL COMBO",
    "drawing": "14782",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "267": {
    "code": "267",
    "name": "1 TON EX SMBP (BUTTERFIELD)",
    "drawing": "14684",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "268": {
    "code": "268",
    "name": "1 TON EX SMBP (THOMPSON)",
    "drawing": "14686",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "269": {
    "code": "269",
    "name": "1 TON EX SMBP (BUTTERFIELD)",
    "drawing": "14687",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "270": {
    "code": "270",
    "name": "1 TON EX SMBP",
    "drawing": "14689",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "273": {
    "code": "273",
    "name": "2000 LITRE STD UNDERGROUND",
    "drawing": "15033",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "275": {
    "code": "275",
    "name": "2160 LITRE STORAGE VESSEL",
    "drawing": "15057",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "276": {
    "code": "276",
    "name": "2000 LITRE EXTENDED FILL UNDERGROUND",
    "drawing": "15131",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "277": {
    "code": "277",
    "name": "2000 LITRE, EXTENDED FILL, ROUND HOOD U/G VESSEL",
    "drawing": "18421",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "278": {
    "code": "278",
    "name": "2000 LITRE UNDERGROUND EX BG",
    "drawing": null,
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "identify"
  },
  "279": {
    "code": "279",
    "name": "1900 LITRE LO SKID VESSEL",
    "drawing": null,
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "identify"
  },
  "280": {
    "code": "280",
    "name": "2000 LITRE COMPETITION COMMISSION TRANSFER",
    "drawing": null,
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "identify"
  },
  "281": {
    "code": "281",
    "name": "2000 LITRE UNDERGROUND COMPETITION COMMISSION TRANSFER(this is a 1200ltr vessel see Nat. Eng)",
    "drawing": null,
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "identify"
  },
  "282": {
    "code": "282",
    "name": "2000 LITRE UNDERGROUND (CONVERTED AG TO UG EX TYPE 291)",
    "drawing": "15134",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "283": {
    "code": "283",
    "name": "2250 LITRE 5 HOLE VERTICAL UG",
    "drawing": "21864",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "284": {
    "code": "284",
    "name": "1 TON EX SMBP",
    "drawing": "14039",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "indexed"
  },
  "285": {
    "code": "285",
    "name": "2000 LITRE EX MIT MBF 1",
    "drawing": "15014",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "286": {
    "code": "286",
    "name": "2000 LITRE EX MBF 2",
    "drawing": "15015",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "287": {
    "code": "287",
    "name": "2000 LITRE EX MIT WEF 1",
    "drawing": "15016",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "288": {
    "code": "288",
    "name": "2000 LITRE EX WEF 2",
    "drawing": "15017",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "289": {
    "code": "289",
    "name": "2000 LITRE EX McK 1",
    "drawing": "15018",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "290": {
    "code": "290",
    "name": "2000 LITRE EX MIT MBF 3",
    "drawing": "15019",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "291": {
    "code": "291",
    "name": "2000 LITRE LOW PROFILE",
    "drawing": "15134",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "292": {
    "code": "292",
    "name": "2000 LITRE 5-IN-LINE LOW PROFILE",
    "drawing": "18422",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "293": {
    "code": "293",
    "name": "1 TON VESSEL SKID",
    "drawing": "19230",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "294": {
    "code": "294",
    "name": "1 TON UNDERGROUND EX-254",
    "drawing": "19586",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "296": {
    "code": "296",
    "name": "2000 LITRE EX-LIOTARD",
    "drawing": "19813",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "ok"
  },
  "297": {
    "code": "297",
    "name": "2000 LITRE (FRENCH -VESSEL CONVERSION PACK 5)",
    "drawing": "19860",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "298": {
    "code": "298",
    "name": "2000 LITRE (FRENCH-VESSEL CONVERSION PACK 6)",
    "drawing": "19897",
    "alternatives": [],
    "capacity": "2000 L",
    "indexPage": 80,
    "section": 3,
    "status": "obsolete"
  },
  "203": {
    "code": "203",
    "name": "4000 Litre 5 HOLE EX EUROGAS UG REQUALIFIED",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "indexed"
  },
  "300": {
    "code": "300",
    "name": "3400 LITRE EX MIT MBF 1",
    "drawing": "15020",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "301": {
    "code": "301",
    "name": "3400 LITRE NON STD SCHNEIDER UK",
    "drawing": "15021",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "302": {
    "code": "302",
    "name": "3400 LITRE EX-LIOTARD",
    "drawing": "19852",
    "alternatives": [
      "323",
      "415"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "303": {
    "code": "303",
    "name": "3400 LITRE EX-LIOTARD",
    "drawing": "19853",
    "alternatives": [
      "323",
      "415"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "304": {
    "code": "304",
    "name": "3400 LITRE EX-LIOTARD",
    "drawing": "19854",
    "alternatives": [
      "323",
      "415"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "305": {
    "code": "305",
    "name": "3400 LITRE COMPETITION COMMISSION TRANSFER 323 415",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "322": {
    "code": "322",
    "name": "3450 LITRE 5 VALVE EX",
    "drawing": "18810",
    "alternatives": [
      "323",
      "415"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "323": {
    "code": "323",
    "name": "3350 LITRE 5 VALVE EX",
    "drawing": "18813",
    "alternatives": [
      "415"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "324": {
    "code": "324",
    "name": "3450 LITRE 5 VALVE EX VAN LEER LOW PRESSURE",
    "drawing": "20078",
    "alternatives": [
      "323",
      "415"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "326": {
    "code": "326",
    "name": "2950 LITRE 5 VALVE EX",
    "drawing": "18814",
    "alternatives": [
      "323",
      "415"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "refer"
  },
  "327": {
    "code": "327",
    "name": "3400 LITRE EX MIT WEF 1",
    "drawing": "15022",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "328": {
    "code": "328",
    "name": "3400 LITRE EX MBF 2",
    "drawing": "15006",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "329": {
    "code": "329",
    "name": "3400 LITRE EX MITR McK 1",
    "drawing": "15028",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "332": {
    "code": "332",
    "name": "2 TON (VAN LEER) 4L",
    "drawing": "14844",
    "alternatives": [
      "349",
      "372"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "333": {
    "code": "333",
    "name": "2 TON EX SWG (ROBERTS) 4L",
    "drawing": "14843",
    "alternatives": [
      "349",
      "372"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "334": {
    "code": "334",
    "name": "2 TON EX BOC (AMF) 4L",
    "drawing": "14842",
    "alternatives": [
      "349",
      "372"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "335": {
    "code": "335",
    "name": "2 TON (VAN LEER) 4L",
    "drawing": "14841",
    "alternatives": [
      "349",
      "372"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "336": {
    "code": "336",
    "name": "2 TON (VAN LEER) 4L",
    "drawing": "14840",
    "alternatives": [
      "349",
      "372"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "337": {
    "code": "337",
    "name": "2 TON EX SWG (ROBERTS) 4L",
    "drawing": "14839",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "338": {
    "code": "338",
    "name": "2 TON EX SWG (W.MID) 4L",
    "drawing": "14838",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "340": {
    "code": "340",
    "name": "2 TON EX SWG (ROBERTS) 4L",
    "drawing": "14836",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "343": {
    "code": "343",
    "name": "2 TON EX SWG (BUTT) 4L",
    "drawing": "14833",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "344": {
    "code": "344",
    "name": "3600 LB (ROBERTS) 4L",
    "drawing": "14832",
    "alternatives": [
      "405"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "345": {
    "code": "345",
    "name": "3600 LB (MASTERS) 4L",
    "drawing": "14831",
    "alternatives": [
      "405"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "346": {
    "code": "346",
    "name": "2 TON F MK III 4L",
    "drawing": "14830",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "347": {
    "code": "347",
    "name": "2 TON EX SWG (VAN LEER) 4L",
    "drawing": "14829",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "348": {
    "code": "348",
    "name": "2 TON EX SWG (ROBERTS) 4L",
    "drawing": "14828",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "349": {
    "code": "349",
    "name": "2 TONNE (BS 1515) 4L",
    "drawing": "14827",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "350": {
    "code": "350",
    "name": "2 TON F MK II 4L",
    "drawing": "14826",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "351": {
    "code": "351",
    "name": "2 TON F MK 1 4L",
    "drawing": "14825",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "357": {
    "code": "357",
    "name": "2 TON (ROBERTS) 4L",
    "drawing": "14756",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "358": {
    "code": "358",
    "name": "2.7 TON (ROBERTS) 4L",
    "drawing": "14755",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "359": {
    "code": "359",
    "name": "2 TON EX SMBP (BUTT) 4L",
    "drawing": "14754",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "360": {
    "code": "360",
    "name": "2 TON BOC (CHS.RBTS) 4L",
    "drawing": "14753",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "361": {
    "code": "361",
    "name": "2 TON EX SWG (WHESSOE) 4L",
    "drawing": "14752",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "362": {
    "code": "362",
    "name": "1.6 TON (THOMPSON/ ROBERTS)",
    "drawing": "14528",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "363": {
    "code": "363",
    "name": "1.6 TON (ROBERTS/AMF)",
    "drawing": "14529",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "364": {
    "code": "364",
    "name": "1.6 TON (ROBERTS)",
    "drawing": "14530",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "365": {
    "code": "365",
    "name": "3600 LB MK I (MASTERS)",
    "drawing": "14205",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "366": {
    "code": "366",
    "name": "3600 LB MK II (ROBERTS)",
    "drawing": "14207",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "367": {
    "code": "367",
    "name": "1.6 TON (THOMPSON)",
    "drawing": "14531",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "368": {
    "code": "368",
    "name": "1.6 TON (THOMPSON/ G'BROOK)",
    "drawing": "14665",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "obsolete"
  },
  "369": {
    "code": "369",
    "name": "2 TON EASYGAS (VAN LEER) 4L",
    "drawing": "14751",
    "alternatives": [
      "405"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "370": {
    "code": "370",
    "name": "2 TON BOC (ROBERTS) 4L",
    "drawing": "14750",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 140,
    "section": 4,
    "status": "ok"
  },
  "371": {
    "code": "371",
    "name": "2 TON MOBIL (ROBERTS) 4L",
    "drawing": "14749",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "372": {
    "code": "372",
    "name": "3400 LITRE STD (BS 5500)",
    "drawing": "14286",
    "alternatives": [
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "373": {
    "code": "373",
    "name": "3400 LITRE N STD",
    "drawing": "15004",
    "alternatives": [
      "372"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "374": {
    "code": "374",
    "name": "2 TON E (McNEIL)",
    "drawing": "14512",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "375": {
    "code": "375",
    "name": "2 TON EX BOC (HARVEY & ROBERTS)",
    "drawing": "14714",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "376": {
    "code": "376",
    "name": "2 TON EX. SWG (BUTTERFIELD)",
    "drawing": "14416",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "379": {
    "code": "379",
    "name": "2 TON EX SWG (ROBERTS)",
    "drawing": "14065",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "indexed"
  },
  "384": {
    "code": "384",
    "name": "2 TON (EX BOC) 4L",
    "drawing": "14747",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "386": {
    "code": "386",
    "name": "2 TON EX SWG (ROBERTS)",
    "drawing": "14235",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "387": {
    "code": "387",
    "name": "2 TON F MK I",
    "drawing": "14279",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "388": {
    "code": "388",
    "name": "2 TON F MK II",
    "drawing": "14280",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "389": {
    "code": "389",
    "name": "2 TON F MK III",
    "drawing": "14275",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "390": {
    "code": "390",
    "name": "2 TON BOC (ROBERTS) 4L",
    "drawing": "14746",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "391": {
    "code": "391",
    "name": "2 TONNE (BS 1515)",
    "drawing": "14290",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "392": {
    "code": "392",
    "name": "2 TONNE (BS 5500)",
    "drawing": "14718",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "393": {
    "code": "393",
    "name": "2 TON (VAN LEER)",
    "drawing": "14405",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "395": {
    "code": "395",
    "name": "2 TON EX BOC (AMF)",
    "drawing": "14409",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "398": {
    "code": "398",
    "name": "3400 LITRE RCG 372 373",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "399": {
    "code": "399",
    "name": "2 TON E (McNEIL) 4L",
    "drawing": "14783",
    "alternatives": [
      "372",
      "373"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "403": {
    "code": "403",
    "name": "3400 LITRE FRENCH DESIGN UNDERGROUND",
    "drawing": "15035",
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "404": {
    "code": "404",
    "name": "3400 LITRE STD UNDERGROUND",
    "drawing": "15034",
    "alternatives": [
      "418"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "405": {
    "code": "405",
    "name": "4000 LITRE STORAGE VESSEL",
    "drawing": "15039",
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "408": {
    "code": "408",
    "name": "3400 LITRE EXTENDED FILL UNDERGROUND",
    "drawing": "15132",
    "alternatives": [
      "418"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "411": {
    "code": "411",
    "name": "4000 LITRE EXTENDED FILL UNDERGROUND",
    "drawing": "18423",
    "alternatives": [
      "418"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "413": {
    "code": "413",
    "name": "4000 LITRE EXTENDED FILL ROUND HOOD U/G",
    "drawing": "18424",
    "alternatives": [
      "418"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "414": {
    "code": "414",
    "name": "4000 LITRE SEPCIAL (2 DRAIN)",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "415": {
    "code": "415",
    "name": "4000 LITRE 5-IN-LINE",
    "drawing": "18425",
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "416": {
    "code": "416",
    "name": "4000 LITRE MARINE GAS",
    "drawing": "18426",
    "alternatives": [
      "415",
      "417"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "417": {
    "code": "417",
    "name": "4000 LITRE SKID VESSEL",
    "drawing": "18427",
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "418": {
    "code": "418",
    "name": "4000 LITRE 5-IN-LINE UNDERGROUND",
    "drawing": "18428",
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "419": {
    "code": "419",
    "name": "4000 LITRE OPS BLENDING (CARE AT STONEY)",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "identify"
  },
  "422": {
    "code": "422",
    "name": "4000 LITRE UNDERGROUND (EX BG) 418",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "424": {
    "code": "424",
    "name": "4000 LITRE ADDITIONAL CONNECTIONS",
    "drawing": "19616",
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "426": {
    "code": "426",
    "name": "4000 LITRE COMPETITION COMMISSION TRANSFER",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "identify"
  },
  "427": {
    "code": "427",
    "name": "4000 LITRE UNDERGROUND COMPETITION COMMISSION TRANSFER 418",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "429": {
    "code": "429",
    "name": "4546 LITRE CAPACITY STORAGE VESSEL",
    "drawing": "20124",
    "alternatives": [
      "405"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "430": {
    "code": "430",
    "name": "4000 LITRE CAPACITY 415",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "431": {
    "code": "431",
    "name": "4200 LITRE SHV STANDARD UNDERGROUND 200-136",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "ok"
  },
  "432": {
    "code": "432",
    "name": "4000 LITRE (WEFCO)",
    "drawing": "20076",
    "alternatives": [
      "415"
    ],
    "capacity": "3400 / 4000 L",
    "indexPage": 141,
    "section": 4,
    "status": "obsolete"
  },
  "401": {
    "code": "401",
    "name": "4 TONNE STD (BS 5500)",
    "drawing": "15029",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "obsolete"
  },
  "406": {
    "code": "406",
    "name": "3.75 T EX BOC",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "obsolete"
  },
  "420": {
    "code": "420",
    "name": "8000 LITRE (2120 DIA) GLENEAGLES",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "identify"
  },
  "428": {
    "code": "428",
    "name": "8000 LITRE VERTICAL (WEFCO)",
    "drawing": "19999",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "645": {
    "code": "645",
    "name": "7 TON MK II STORAGE VESSEL",
    "drawing": "15042",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "646": {
    "code": "646",
    "name": "7 TON MK III STORAGE VESSEL",
    "drawing": "15043",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "647": {
    "code": "647",
    "name": "7 TON MK1 MOD",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "obsolete"
  },
  "648": {
    "code": "648",
    "name": "7 TON MK2 MOD",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "obsolete"
  },
  "649": {
    "code": "649",
    "name": "7 TON MK3 MOD",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "obsolete"
  },
  "650": {
    "code": "650",
    "name": "12 TON MK1",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "identify"
  },
  "651": {
    "code": "651",
    "name": "12 TON MK II STORAGE VESSEL (DOWN RATED)",
    "drawing": "15040",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "652": {
    "code": "652",
    "name": "12 TON MK III STORAGE VESSEL (DOWN RATED)",
    "drawing": "15041",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "653": {
    "code": "653",
    "name": "12 TON METRIC STORAGE VESSEL (HEMISPHERICAL ENDS)",
    "drawing": "15060",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "654": {
    "code": "654",
    "name": "12 TON METRIC STORAGE VESSEL (ELLIPSOIDAL ENDS)",
    "drawing": "15061",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "656": {
    "code": "656",
    "name": "12 TON MK I (MODIFIED) STORAGE VESSEL",
    "drawing": "14261",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "657": {
    "code": "657",
    "name": "12 TON MK 2 (MODIFIED) STORAGE VESSEL",
    "drawing": "14264",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "658": {
    "code": "658",
    "name": "12 TON MK3 (MODIFIED) STORAGE VESSEL",
    "drawing": "14266",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "659": {
    "code": "659",
    "name": "12 TON UNDERGROUND NO C/P",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "660": {
    "code": "660",
    "name": "12 TON UNDERGROUND WITH C/P",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "661": {
    "code": "661",
    "name": "12 TON METRIC MODIFIED",
    "drawing": "20219",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "662": {
    "code": "662",
    "name": "12 TON MK 2 (MODIFIED 652) FOR VAPOURISER",
    "drawing": "20005",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "664": {
    "code": "664",
    "name": "12 TON MK 2 (MODIFIED 651) FOR VAPOURISER (GREEN)",
    "drawing": "20384",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "665": {
    "code": "665",
    "name": "12 TON MOUNDED STORAGE VESSEL",
    "drawing": "20393",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "666": {
    "code": "666",
    "name": "24 TON MOUNDED STORAGE VESSEL",
    "drawing": "21162",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "670": {
    "code": "670",
    "name": "21 TON STORAGE VESSEL (UNMODIFIED)",
    "drawing": "15116",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "671": {
    "code": "671",
    "name": "21 TON STORAGE VESSEL (UP RATED)",
    "drawing": "15117",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "672": {
    "code": "672",
    "name": "21 TON STORAGE VESSEL (MODIFIED - GATWICK)",
    "drawing": "15118",
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "673": {
    "code": "673",
    "name": "21 TON UNDERGROUND WITH CP (LAKENHEATH)",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "674": {
    "code": "674",
    "name": "24 TON UNDERGROUND WIITH CP (AVIEMORE)",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "675": {
    "code": "675",
    "name": "50 TON UNDERGROUND WIITH CP (LAKENHEATH)",
    "drawing": null,
    "alternatives": [],
    "capacity": ">4000 L",
    "indexPage": 213,
    "section": 5,
    "status": "indexed"
  },
  "032": {
    "code": "032",
    "name": "380 LITRE 5 VALVE EX",
    "drawing": "18811",
    "alternatives": [],
    "capacity": "≤380 L",
    "indexPage": 8,
    "section": 1,
    "status": "ok"
  },
  "320": {
    "code": "320",
    "name": "3400 LITRE EX MIT WEF 3 / combo (obsolete schedule)",
    "drawing": null,
    "alternatives": [],
    "capacity": "3400 / 4000 L",
    "indexPage": 145,
    "section": 4,
    "status": "obsolete"
  },
  "394": {
    "code": "394",
    "name": "Type 394",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 146,
    "section": null,
    "status": "obsolete"
  },
  "396": {
    "code": "396",
    "name": "Type 396",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 146,
    "section": null,
    "status": "obsolete"
  },
  "397": {
    "code": "397",
    "name": "Type 397",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 146,
    "section": null,
    "status": "obsolete"
  },
  "500": {
    "code": "500",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "501": {
    "code": "501",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "502": {
    "code": "502",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "503": {
    "code": "503",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "504": {
    "code": "504",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "505": {
    "code": "505",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "506": {
    "code": "506",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "507": {
    "code": "507",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "508": {
    "code": "508",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "509": {
    "code": "509",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "510": {
    "code": "510",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "511": {
    "code": "511",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "512": {
    "code": "512",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "513": {
    "code": "513",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "514": {
    "code": "514",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "515": {
    "code": "515",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "516": {
    "code": "516",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "517": {
    "code": "517",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "518": {
    "code": "518",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "519": {
    "code": "519",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "520": {
    "code": "520",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "521": {
    "code": "521",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "522": {
    "code": "522",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "523": {
    "code": "523",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "524": {
    "code": "524",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "525": {
    "code": "525",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "526": {
    "code": "526",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "527": {
    "code": "527",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "528": {
    "code": "528",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "529": {
    "code": "529",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "530": {
    "code": "530",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "531": {
    "code": "531",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "532": {
    "code": "532",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "533": {
    "code": "533",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "534": {
    "code": "534",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "535": {
    "code": "535",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "536": {
    "code": "536",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "537": {
    "code": "537",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "538": {
    "code": "538",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "539": {
    "code": "539",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "540": {
    "code": "540",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "541": {
    "code": "541",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "542": {
    "code": "542",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "543": {
    "code": "543",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "544": {
    "code": "544",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "545": {
    "code": "545",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "546": {
    "code": "546",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "547": {
    "code": "547",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "548": {
    "code": "548",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "549": {
    "code": "549",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "550": {
    "code": "550",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "551": {
    "code": "551",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "552": {
    "code": "552",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "553": {
    "code": "553",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "554": {
    "code": "554",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "555": {
    "code": "555",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "556": {
    "code": "556",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "557": {
    "code": "557",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "558": {
    "code": "558",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "559": {
    "code": "559",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "560": {
    "code": "560",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "561": {
    "code": "561",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "562": {
    "code": "562",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "563": {
    "code": "563",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "564": {
    "code": "564",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "565": {
    "code": "565",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "566": {
    "code": "566",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "567": {
    "code": "567",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "568": {
    "code": "568",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "569": {
    "code": "569",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "570": {
    "code": "570",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "571": {
    "code": "571",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "572": {
    "code": "572",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "573": {
    "code": "573",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "574": {
    "code": "574",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "575": {
    "code": "575",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "576": {
    "code": "576",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "577": {
    "code": "577",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "578": {
    "code": "578",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "579": {
    "code": "579",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "580": {
    "code": "580",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "581": {
    "code": "581",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "582": {
    "code": "582",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "583": {
    "code": "583",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "584": {
    "code": "584",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "585": {
    "code": "585",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "586": {
    "code": "586",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "587": {
    "code": "587",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "588": {
    "code": "588",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "589": {
    "code": "589",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "590": {
    "code": "590",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "591": {
    "code": "591",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "592": {
    "code": "592",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "593": {
    "code": "593",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "594": {
    "code": "594",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "595": {
    "code": "595",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "596": {
    "code": "596",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "597": {
    "code": "597",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "598": {
    "code": "598",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  },
  "599": {
    "code": "599",
    "name": "Dummy type code",
    "drawing": null,
    "alternatives": [],
    "capacity": "",
    "indexPage": 5,
    "section": 0,
    "status": "dummy"
  }
};

export const VID_SCHEDULES = {
  "032": {
    "layout": "5-hole",
    "pages": {
      "new": 9
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 124 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013360",
        "torqueKey": "float",
        "details": "Type 611"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "existing": null,
    "obsoleteOnly": false
  },
  "014": {
    "layout": "3-hole",
    "pages": {
      "new": 10,
      "existing": 10
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66623",
        "torqueKey": "combo",
        "details": "OPD 135 mm from top of tank boss; FLL 139 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013360",
        "torqueKey": "float",
        "details": "Type 611"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14166",
        "torqueKey": null,
        "details": "Length 636 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14250",
        "torqueKey": null,
        "details": "Length 192 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013360",
        "torqueKey": "float",
        "details": "Type 611"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "019": {
    "layout": "3-hole",
    "pages": {
      "new": 10,
      "existing": 10
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66623",
        "torqueKey": "combo",
        "details": "OPD 135 mm from top of tank boss; FLL 139 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013360",
        "torqueKey": "float",
        "details": "Type 611"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14166",
        "torqueKey": null,
        "details": "Length 636 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14250",
        "torqueKey": null,
        "details": "Length 192 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013360",
        "torqueKey": "float",
        "details": "Type 611"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "009": {
    "layout": "3-hole",
    "pages": {
      "existing": 10
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14201",
        "torqueKey": null,
        "details": "Length 255 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013351",
        "torqueKey": "float",
        "details": "Type 601"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "010": {
    "layout": "3-hole",
    "pages": {
      "existing": 10
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14201",
        "torqueKey": null,
        "details": "Length 255 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013351",
        "torqueKey": "float",
        "details": "Type 601"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "011": {
    "layout": "3-hole",
    "pages": {
      "existing": 10
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14124",
        "torqueKey": null,
        "details": "Length 825 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013359",
        "torqueKey": "float",
        "details": "Type 610"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "017009",
        "torqueKey": null,
        "details": "Type SC104/19"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "3",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "013": {
    "layout": "3-hole",
    "pages": {
      "existing": 10
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14166",
        "torqueKey": null,
        "details": "Length 636 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14201",
        "torqueKey": null,
        "details": "Length 225 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013360",
        "torqueKey": "float",
        "details": "Type 611"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "3/8\" BSW",
        "torqueKey": null,
        "details": "Type 3441"
      }
    ],
    "obsoleteOnly": false
  },
  "044": {
    "layout": "3-hole",
    "pages": {
      "existing": 10
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14201",
        "torqueKey": null,
        "details": "Length 255 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "13360",
        "torqueKey": "float",
        "details": "Type 611"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "003": {
    "layout": "3-hole",
    "pages": {
      "existing": 11
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013351",
        "torqueKey": "float",
        "details": "Type 601"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "004": {
    "layout": "3-hole",
    "pages": {
      "existing": 11
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013351",
        "torqueKey": "float",
        "details": "Type 601"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "005": {
    "layout": "3-hole",
    "pages": {
      "existing": 11
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013351",
        "torqueKey": "float",
        "details": "Type 601"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "006": {
    "layout": "3-hole",
    "pages": {
      "existing": 11
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013351",
        "torqueKey": "float",
        "details": "Type 601"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "007": {
    "layout": "3-hole",
    "pages": {
      "existing": 11
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013351",
        "torqueKey": "float",
        "details": "Type 601"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "008": {
    "layout": "3-hole",
    "pages": {
      "existing": 11
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14167",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 734 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013351",
        "torqueKey": "float",
        "details": "Type 601"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "026": {
    "layout": "3-hole",
    "pages": {
      "existing": 11
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14166",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 636 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013360",
        "torqueKey": "float",
        "details": "Type 611"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "158": {
    "layout": "5-hole",
    "pages": {
      "new": 31,
      "existing": 31
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 201 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 201 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "obsoleteOnly": false
  },
  "159": {
    "layout": "5-hole",
    "pages": {
      "new": 31,
      "existing": 31
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 201 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "66608",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 201 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "012609",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": false
  },
  "171": {
    "layout": "5-hole",
    "pages": {
      "new": 31,
      "existing": 31
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 196 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "66608",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Thread M6 Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "104756",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "020474",
        "torqueKey": null,
        "details": "¾″ plug"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 196 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "012609",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Thread M6 Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "104756",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "020474",
        "torqueKey": null,
        "details": "¾″ plug"
      }
    ],
    "obsoleteOnly": false
  },
  "172": {
    "layout": "5-hole",
    "pages": {
      "new": 31,
      "existing": 31
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 354 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "66608",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler with OPD",
        "itemNo": "66616",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013367",
        "torqueKey": "float",
        "details": "Thread 1/4\" UNF Type 623"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Tecni-form"
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "020474",
        "torqueKey": null,
        "details": "¾″ plug"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 354 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "012609",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler",
        "itemNo": "012613",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013367",
        "torqueKey": "float",
        "details": "Thread 1/4\" UNF Type 623"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Tecni-form"
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "020474",
        "torqueKey": null,
        "details": "¾″ plug"
      }
    ],
    "obsoleteOnly": false
  },
  "180": {
    "layout": "5-hole",
    "pages": {
      "existing": 31
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 318 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "012609",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler",
        "itemNo": "012613",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Thread M6 Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "",
        "torqueKey": null,
        "details": "Merloni"
      }
    ],
    "obsoleteOnly": false
  },
  "201": {
    "layout": "5-hole",
    "pages": {
      "existing": 31
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "66608",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler",
        "itemNo": "012613",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": false
  },
  "121": {
    "layout": "3-hole",
    "pages": {
      "new": 32,
      "existing": 32
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 218 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "133": {
    "layout": "3-hole",
    "pages": {
      "new": 32,
      "existing": 32
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 218 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "146": {
    "layout": "3-hole",
    "pages": {
      "new": 32,
      "existing": 32
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 218 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "148": {
    "layout": "3-hole",
    "pages": {
      "new": 32,
      "existing": 32
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 218 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "155": {
    "layout": "3-hole",
    "pages": {
      "new": 32,
      "existing": 32
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 218 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "None",
        "torqueKey": null,
        "details": "qty 1 — No adaptor listed."
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "8685 G",
        "torqueKey": null,
        "details": "Type None — No torque listed in VID Section 10 for this arrangement — refer to National Engineering."
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "None",
        "torqueKey": null,
        "details": "Type None; qty 1 — No adaptor listed."
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "8685 G",
        "torqueKey": null,
        "details": "Type None — No torque listed in VID Section 10 for this arrangement — refer to National Engineering."
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "120": {
    "layout": "3-hole",
    "pages": {
      "existing": 32
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14124",
        "torqueKey": null,
        "details": "Length 825 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14201",
        "torqueKey": null,
        "details": "Length 255 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013359",
        "torqueKey": "float",
        "details": "Type 610"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "128": {
    "layout": "3-hole",
    "pages": {
      "existing": 32
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14255",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "3/8\" BSW",
        "torqueKey": null,
        "details": "Type 3441"
      }
    ],
    "obsoleteOnly": false
  },
  "129": {
    "layout": "3-hole",
    "pages": {
      "existing": 32
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14255",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "3/8\" BSW",
        "torqueKey": null,
        "details": "Type 3441"
      }
    ],
    "obsoleteOnly": false
  },
  "130": {
    "layout": "3-hole",
    "pages": {
      "existing": 32
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14255",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "132": {
    "layout": "3-hole",
    "pages": {
      "existing": 32
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14255",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "145": {
    "layout": "3-hole",
    "pages": {
      "existing": 32
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "169": {
    "layout": "3-hole",
    "pages": {
      "existing": 32
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14255",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "156": {
    "layout": "3-hole",
    "pages": {
      "existing": 32
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14232",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "None",
        "torqueKey": null,
        "details": "Type None; qty 1 — No adaptor listed."
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "8686 G",
        "torqueKey": null,
        "details": "Type None — No torque listed in VID Section 10 for this arrangement — refer to National Engineering."
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      },
      {
        "position": "G",
        "name": "Liquid extra — EFV",
        "itemNo": "2723C",
        "torqueKey": "steel_npt",
        "details": "¾″ dip pipe + ¾″ NPT 25230 (liquid arrangement)"
      },
      {
        "position": "G",
        "name": "Vapour extra",
        "itemNo": "8013DA",
        "torqueKey": null,
        "details": "Type 12507; 1″ 25231 (vapour arrangement)"
      }
    ],
    "obsoleteOnly": false
  },
  "116": {
    "layout": "5-hole",
    "pages": {
      "existing": 33
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 168 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013359",
        "torqueKey": "float",
        "details": "Thread 1/4\" UNF Type 610"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14483",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "020469",
        "torqueKey": null,
        "details": "1¼″ plug"
      }
    ],
    "obsoleteOnly": true
  },
  "225": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Thread 1/4\" UNF Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "G",
        "name": "Spare/additional kit",
        "itemNo": "012509 / 025223 / 020469",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV, ball valve, plug. Steel-to-steel: hand tight + 3 turns; do not unscrew to orient."
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "G",
        "name": "Spare/additional kit",
        "itemNo": "012509 / 025223 / 020469",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV, ball valve, plug. Steel-to-steel: hand tight + 3 turns; do not unscrew to orient."
      }
    ],
    "obsoleteOnly": false
  },
  "227": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 386 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler with OPD",
        "itemNo": "66617",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013369",
        "torqueKey": "float",
        "details": "Type 625"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Alternative float gauge",
        "itemNo": "013368",
        "torqueKey": "float",
        "details": "N.B. Alt. Float (VID margin note)"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 386 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler",
        "itemNo": "012613",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013369",
        "torqueKey": "float",
        "details": "Type 625"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Alternative float gauge",
        "itemNo": "013368",
        "torqueKey": "float",
        "details": "N.B. Alt. Float (VID margin note)"
      }
    ],
    "obsoleteOnly": false
  },
  "229": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      }
    ],
    "obsoleteOnly": false
  },
  "232": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 334 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler with OPD",
        "itemNo": "66616",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013367",
        "torqueKey": "float",
        "details": "Type 623"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 334 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler",
        "itemNo": "012613",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013367",
        "torqueKey": "float",
        "details": "Type 623"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": false
  },
  "233": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV"
      },
      {
        "position": "L",
        "name": "By-pass return",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV"
      },
      {
        "position": "L",
        "name": "By-pass return",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV"
      }
    ],
    "obsoleteOnly": false
  },
  "234": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": false
  },
  "235": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": false
  },
  "237": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": false
  },
  "236": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "66608",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "012609",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": false
  },
  "238": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "obsoleteOnly": false
  },
  "292": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "obsoleteOnly": false
  },
  "296": {
    "layout": "5-hole",
    "pages": {
      "new": 81,
      "existing": 81
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 199 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66621",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "obsoleteOnly": false
  },
  "283": {
    "layout": "5-hole",
    "pages": {
      "existing": 81
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 389 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "66608",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler",
        "itemNo": "012613",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "",
        "torqueKey": "float",
        "details": "Thread M6"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "",
        "torqueKey": null,
        "details": "Merloni"
      }
    ],
    "obsoleteOnly": false
  },
  "258": {
    "layout": "3-hole",
    "pages": {
      "new": 82,
      "existing": 82
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 215 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "273": {
    "layout": "3-hole",
    "pages": {
      "new": 82,
      "existing": 82
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 215 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "275": {
    "layout": "3-hole",
    "pages": {
      "new": 82,
      "existing": 82
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 215 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "286": {
    "layout": "3-hole",
    "pages": {
      "new": 82,
      "existing": 82
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 215 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "291": {
    "layout": "3-hole",
    "pages": {
      "new": 82,
      "existing": 82
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66624",
        "torqueKey": "combo",
        "details": "OPD 200 mm from top of tank boss; FLL 215 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014170",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "220": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103394",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1215 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 380 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013367",
        "torqueKey": "float",
        "details": "Type 623"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Type Tecniform"
      }
    ],
    "obsoleteOnly": false
  },
  "239": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103395",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "None",
        "torqueKey": null,
        "details": "Type None; qty 1 — No adaptor listed."
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "8685 G",
        "torqueKey": null,
        "details": "Type None — No torque listed in VID Section 10 for this arrangement — refer to National Engineering."
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "241": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "None",
        "torqueKey": null,
        "details": "Type None; qty 1 — No adaptor listed."
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "8686 G",
        "torqueKey": null,
        "details": "Type None — No torque listed in VID Section 10 for this arrangement — refer to National Engineering."
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "242": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "254": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "256": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "276": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103394",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1215 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 459 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013367",
        "torqueKey": "float",
        "details": "Type 623"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Type UG"
      }
    ],
    "obsoleteOnly": false
  },
  "277": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103394",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1215 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 459 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013367",
        "torqueKey": "float",
        "details": "Type 623"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Type UG"
      }
    ],
    "obsoleteOnly": false
  },
  "279": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "TBA",
        "torqueKey": "float",
        "details": "Type None"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "282": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103394",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1215 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 459 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013367",
        "torqueKey": "float",
        "details": "Type 623"
      }
    ],
    "obsoleteOnly": false
  },
  "293": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      }
    ],
    "obsoleteOnly": false
  },
  "294": {
    "layout": "3-hole",
    "pages": {
      "existing": 82
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103394",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "014173",
        "torqueKey": null,
        "details": "Length 1415 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 496 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013368",
        "torqueKey": "float",
        "details": "Type 624"
      }
    ],
    "obsoleteOnly": false
  },
  "297": {
    "layout": "5-hole",
    "pages": {
      "existing": 83
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": true
  },
  "298": {
    "layout": "5-hole",
    "pages": {
      "existing": 83
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": true
  },
  "323": {
    "layout": "5-hole",
    "pages": {
      "new": 142,
      "existing": 142
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66615",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      }
    ],
    "obsoleteOnly": false
  },
  "415": {
    "layout": "5-hole",
    "pages": {
      "new": 142,
      "existing": 142
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66615",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      }
    ],
    "obsoleteOnly": false
  },
  "416": {
    "layout": "5-hole",
    "pages": {
      "new": 142,
      "existing": 142
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66615",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      },
      {
        "position": "E",
        "name": "Earth",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": ""
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      },
      {
        "position": "E",
        "name": "Earth",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": ""
      }
    ],
    "obsoleteOnly": false
  },
  "417": {
    "layout": "5-hole",
    "pages": {
      "new": 142,
      "existing": 142
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler with OPD",
        "itemNo": "66615",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      },
      {
        "position": "E",
        "name": "Earth",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": ""
      },
      {
        "position": "L",
        "name": "By-pass return",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": ""
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      },
      {
        "position": "E",
        "name": "Earth",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Drain / liquid outlet",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": ""
      },
      {
        "position": "L",
        "name": "By-pass return",
        "itemNo": "12509",
        "torqueKey": "steel_npt",
        "details": ""
      }
    ],
    "obsoleteOnly": false
  },
  "418": {
    "layout": "5-hole",
    "pages": {
      "new": 142,
      "existing": 142
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 373 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "66622",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler with OPD",
        "itemNo": "66617",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013368",
        "torqueKey": "float",
        "details": "Type 624"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 373 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler",
        "itemNo": "012613",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013368",
        "torqueKey": "float",
        "details": "Type 624"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      }
    ],
    "obsoleteOnly": false
  },
  "431": {
    "layout": "5-hole",
    "pages": {
      "new": 142,
      "existing": 142
    },
    "new": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 343 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "66608",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler with OPD",
        "itemNo": "66617",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013369",
        "torqueKey": "float",
        "details": "Type 625"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Alternative float gauge",
        "itemNo": "013368",
        "torqueKey": "float",
        "details": ""
      }
    ],
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 343 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "012609",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Straight filler",
        "itemNo": "012613",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013369",
        "torqueKey": "float",
        "details": "Type 625"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Alternative float gauge",
        "itemNo": "013368",
        "torqueKey": "float",
        "details": ""
      }
    ],
    "obsoleteOnly": false
  },
  "372": {
    "layout": "3-hole",
    "pages": {
      "new": 143,
      "existing": 143
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66625",
        "torqueKey": "combo",
        "details": "OPD 230 mm from top of tank boss; FLL 269 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "373": {
    "layout": "3-hole",
    "pages": {
      "new": 143,
      "existing": 143
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66625",
        "torqueKey": "combo",
        "details": "OPD 230 mm from top of tank boss; FLL 269 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "405": {
    "layout": "3-hole",
    "pages": {
      "new": 143,
      "existing": 143
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66625",
        "torqueKey": "combo",
        "details": "OPD 230 mm from top of tank boss; FLL 269 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "424": {
    "layout": "3-hole",
    "pages": {
      "new": 143,
      "existing": 143
    },
    "new": [
      {
        "position": "A",
        "name": "Combo valve with OPD",
        "itemNo": "66625",
        "torqueKey": "combo",
        "details": "OPD 230 mm from top of tank boss; FLL 269 mm from bottom of valve thread"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      },
      {
        "position": "H",
        "name": "Vapour outlet kit",
        "itemNo": "12509 / 25223 / 20469",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV, 1¼″ ball valve, 1¼″ plug. Steel-to-steel: hand tight + 3 turns; do not unscrew to orient."
      },
      {
        "position": "P",
        "name": "Liquid outlet kit",
        "itemNo": "12509 / 25223 / 20469",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV, 1¼″ ball valve, 1¼″ plug. Steel-to-steel: hand tight + 3 turns; do not unscrew to orient."
      },
      {
        "position": "Q",
        "name": "Vapour return kit",
        "itemNo": "12500 / 25223 / 20469",
        "torqueKey": "steel_npt",
        "details": "2″ EFV, 2″ ball valve, 2″ plug. Steel-to-steel: hand tight + 3 turns; do not unscrew to orient."
      }
    ],
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "66625",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1415 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14253",
        "torqueKey": null,
        "details": "Length 269 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      },
      {
        "position": "H",
        "name": "Vapour outlet kit",
        "itemNo": "12509 / 25223 / 20469",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV, 1¼″ ball valve, 1¼″ plug. Steel-to-steel: hand tight + 3 turns; do not unscrew to orient."
      },
      {
        "position": "P",
        "name": "Liquid outlet kit",
        "itemNo": "12509 / 25223 / 20469",
        "torqueKey": "steel_npt",
        "details": "1¼″ EFV, 1¼″ ball valve, 1¼″ plug. Steel-to-steel: hand tight + 3 turns; do not unscrew to orient."
      },
      {
        "position": "Q",
        "name": "Vapour return kit",
        "itemNo": "12500 / 25223 / 20469",
        "torqueKey": "steel_npt",
        "details": "2″ EFV, 2″ ball valve, 2″ plug. Steel-to-steel: hand tight + 3 turns; do not unscrew to orient."
      }
    ],
    "obsoleteOnly": false
  },
  "328": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "332": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14119",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "333": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14119",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "335": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14119",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "336": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14119",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "369": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14119",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "334": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "340": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "347": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "349": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "343": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "346": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "348": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "350": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "351": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "359": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "370": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "384": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "392": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "403": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Type UG"
      }
    ],
    "obsoleteOnly": false
  },
  "404": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Type UG"
      }
    ],
    "obsoleteOnly": false
  },
  "408": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103394",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1415 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 496 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Type UG"
      }
    ],
    "obsoleteOnly": false
  },
  "411": {
    "layout": "3-hole",
    "pages": {
      "existing": 146
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103394",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 1415 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253164",
        "torqueKey": null,
        "details": "Length 496 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "17029/30",
        "torqueKey": null,
        "details": "Type UG"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "",
        "torqueKey": null,
        "details": "None"
      }
    ],
    "obsoleteOnly": false
  },
  "413": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "103394",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14173",
        "torqueKey": null,
        "details": "Length 1415 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "19253",
        "torqueKey": null,
        "details": "Length 496 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "429": {
    "layout": "3-hole",
    "pages": {
      "existing": 143
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "14172",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "14256",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "13355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": false
  },
  "302": {
    "layout": "5-hole",
    "pages": {
      "existing": 144
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Thread M6 or 1/4\" UNF Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Plug",
        "itemNo": "",
        "torqueKey": null,
        "details": "¾″ and 2″ plugs"
      }
    ],
    "obsoleteOnly": true
  },
  "303": {
    "layout": "5-hole",
    "pages": {
      "existing": 144
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Thread M6 or 1/4\" UNF Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Plug",
        "itemNo": "",
        "torqueKey": null,
        "details": "¾″ plug"
      }
    ],
    "obsoleteOnly": true
  },
  "304": {
    "layout": "5-hole",
    "pages": {
      "existing": 144
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "012609",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Thread M6 or 1/4\" UNF Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Plug",
        "itemNo": "",
        "torqueKey": null,
        "details": "¾″ plug"
      }
    ],
    "obsoleteOnly": true
  },
  "432": {
    "layout": "5-hole",
    "pages": {
      "existing": 144
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Thread M6 or 1/4\" UNF Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17"
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Plug",
        "itemNo": "",
        "torqueKey": null,
        "details": "1¼″ plugs"
      }
    ],
    "obsoleteOnly": true
  },
  "322": {
    "layout": "5-hole",
    "pages": {
      "existing": 144
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12158",
        "torqueKey": "rv",
        "details": "Type Euro 17"
      },
      {
        "position": "E",
        "name": "Earth",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "B",
        "name": "Alternative RVA/RV",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "535 + 12155 25/12 17 (second VID row for type 322)"
      }
    ],
    "obsoleteOnly": true
  },
  "324": {
    "layout": "5-hole",
    "pages": {
      "existing": 144
    },
    "new": null,
    "existing": [
      {
        "position": "H",
        "name": "Vapour offtake valve",
        "itemNo": "012607",
        "torqueKey": "vapour_5",
        "details": "Dip length 237 mm"
      },
      {
        "position": "K",
        "name": "Liquid unloading ¾″ check lock",
        "itemNo": "012608",
        "torqueKey": "cl_34",
        "details": ""
      },
      {
        "position": "K",
        "name": "Liquid unloading 1¼″ check lock",
        "itemNo": "012609",
        "torqueKey": "cl_114",
        "details": ""
      },
      {
        "position": "J",
        "name": "Angled filler",
        "itemNo": "012614",
        "torqueKey": "filler_5",
        "details": ""
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Thread M6 Type 606"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12154",
        "torqueKey": "rv",
        "details": "Type 25/12 14.5"
      },
      {
        "position": "E",
        "name": "Earth",
        "itemNo": "14128",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "D",
        "name": "Cover",
        "itemNo": "14484",
        "torqueKey": null,
        "details": ""
      },
      {
        "position": "F",
        "name": "Plug",
        "itemNo": "",
        "torqueKey": null,
        "details": "1¼″ plug"
      }
    ],
    "obsoleteOnly": true
  },
  "300": {
    "layout": "3-hole",
    "pages": {
      "existing": 145
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253152",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "301": {
    "layout": "3-hole",
    "pages": {
      "existing": 145
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253152",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "327": {
    "layout": "3-hole",
    "pages": {
      "existing": 145
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253152",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "320": {
    "layout": "3-hole",
    "pages": {
      "existing": 145
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253152",
        "torqueKey": null,
        "details": "Length 306 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "329": {
    "layout": "3-hole",
    "pages": {
      "existing": 145
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 1224 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253152",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "365": {
    "layout": "3-hole",
    "pages": {
      "existing": 145
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "253108",
        "torqueKey": null,
        "details": "Length 1025 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253151",
        "torqueKey": null,
        "details": "Length 295 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12155",
        "torqueKey": "rv",
        "details": "Type 25/12 17.2"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013353",
        "torqueKey": "float",
        "details": "Type 604"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "393": {
    "layout": "3-hole",
    "pages": {
      "existing": 146
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "253106",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253158",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12154",
        "torqueKey": "rv",
        "details": "Type 25/12 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "394": {
    "layout": "3-hole",
    "pages": {
      "existing": 146
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "253106",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253158",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12154",
        "torqueKey": "rv",
        "details": "Type 25/12 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "395": {
    "layout": "3-hole",
    "pages": {
      "existing": 146
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "253106",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253158",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12154",
        "torqueKey": "rv",
        "details": "Type 25/12 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "396": {
    "layout": "3-hole",
    "pages": {
      "existing": 146
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "253106",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253158",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12154",
        "torqueKey": "rv",
        "details": "Type 25/12 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "397": {
    "layout": "3-hole",
    "pages": {
      "existing": 146
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "253106",
        "torqueKey": null,
        "details": "Length 1275 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253158",
        "torqueKey": null,
        "details": "Length 331 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12207",
        "torqueKey": "rva",
        "details": "Type 535; qty 1"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12154",
        "torqueKey": "rv",
        "details": "Type 25/12 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013355",
        "torqueKey": "float",
        "details": "Type 606"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "399": {
    "layout": "3-hole",
    "pages": {
      "existing": 146
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "",
        "torqueKey": null,
        "details": "Length 1423 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253154",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12205",
        "torqueKey": "rva",
        "details": "Type M36; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12157",
        "torqueKey": "rv",
        "details": "Type Euro 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013357",
        "torqueKey": "float",
        "details": "Type 608"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  },
  "401": {
    "layout": "3-hole",
    "pages": {
      "existing": 146
    },
    "new": null,
    "existing": [
      {
        "position": "A",
        "name": "Combo valve (existing)",
        "itemNo": "11404",
        "torqueKey": "combo",
        "details": ""
      },
      {
        "position": "A",
        "name": "Eduction tube",
        "itemNo": "253109",
        "torqueKey": null,
        "details": "Length 1523 mm"
      },
      {
        "position": "A",
        "name": "Dip tube",
        "itemNo": "253159",
        "torqueKey": null,
        "details": "Length 368 mm"
      },
      {
        "position": "B",
        "name": "Relief valve adaptor",
        "itemNo": "12208",
        "torqueKey": "rva",
        "details": "Type 545; qty 2"
      },
      {
        "position": "B",
        "name": "Relief valve",
        "itemNo": "12154",
        "torqueKey": "rv",
        "details": "Type 25/12 14.5"
      },
      {
        "position": "C",
        "name": "Float gauge",
        "itemNo": "013366",
        "torqueKey": "float",
        "details": "Type 617"
      },
      {
        "position": "D",
        "name": "Hood",
        "itemNo": "104756/7",
        "torqueKey": null,
        "details": "Type 14484"
      },
      {
        "position": "E",
        "name": "Earth connection",
        "itemNo": "M10",
        "torqueKey": null,
        "details": "Type 14128"
      }
    ],
    "obsoleteOnly": true
  }
};
